export enum EnumProductGA {
  SAME_MANUFACTURER = 'SAME_MANUFACTURER',
  SAME_INGREDIENT = 'SAME_INGREDIENT',
}
